import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { NAVIGATION_LINKS } from "../utils/constants";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  return (
    <>
      {/* Topbar */}
      <div className="bg-blue-700 text-white text-xs">
        <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-between gap-2">
          <div className="flex flex-wrap items-center gap-4">
            <a
              href="mailto:info@ommaruticreation.com"
              className="flex items-center gap-1.5 text-white/80 hover:text-white transition"
            >
              <FaEnvelope size={11} />
              info@ommaruticreation.com
            </a>
            <a
              href="tel:+910987654321"
              className="flex items-center gap-1.5 text-white/80 hover:text-white transition"
            >
              <FaPhone size={11} />
              +91 0987654321
            </a>
            <span className="hidden md:flex items-center gap-1.5 text-white/80">
              <FaMapMarkerAlt size={11} />
              Peenya 2nd Stage, Bangalore
            </span>
          </div>
          <div className="flex items-center gap-3">
            {[
              { Icon: FaFacebook, label: "Facebook" },
              { Icon: FaInstagram, label: "Instagram" },
              { Icon: FaLinkedin, label: "LinkedIn" },
              { Icon: FaYoutube, label: "YouTube" },
              { Icon: FaWhatsapp, label: "WhatsApp" },
            ].map(({ Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                className="text-white/80 hover:text-white transition"
              >
                <Icon size={13} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`bg-white sticky top-0 z-50 transition-shadow duration-300 ${
          scrolled ? "shadow-md" : "shadow-sm"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-[72px]">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 flex-shrink-0">
              <img
                src="/images/logo.png"
                alt="OM Maruti Creation"
                className="h-14 w-auto"
              />
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-1">
              {NAVIGATION_LINKS.map(({ path, label }) => (
                <Link
                  key={path}
                  to={path}
                  className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 group ${
                    isActive(path)
                      ? "text-blue-700"
                      : "text-gray-700 hover:text-blue-700"
                  }`}
                >
                  {label}
                  <span
                    className={`absolute bottom-0 left-1/2 -translate-x-1/2 h-0.5 bg-blue-700 rounded-full transition-all duration-300 ${
                      isActive(path) ? "w-5" : "w-0 group-hover:w-5"
                    }`}
                  />
                </Link>
              ))}
            </nav>

            {/* CTA + Hamburger */}
            <div className="flex items-center gap-3">
              <Link
                to="/contact"
                className="hidden lg:inline-flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition duration-200 shadow-sm hover:shadow-md"
              >
                Get Quote
              </Link>
              <button
                className="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Nav */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 border-t border-gray-100 ${
            isMenuOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <nav className="bg-white px-4 py-3 flex flex-col gap-1">
            {NAVIGATION_LINKS.map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                className={`px-4 py-2.5 rounded-xl text-sm font-medium transition ${
                  isActive(path)
                    ? "bg-blue-50 text-blue-700"
                    : "text-gray-700 hover:bg-gray-50"
                }`}
              >
                {label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-2 bg-blue-700 text-white text-sm font-semibold text-center px-5 py-3 rounded-xl hover:bg-blue-800 transition"
            >
              Get Quote
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
